"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tailwind_1 = require("../constants/tailwind");
var accordion_1 = require("../modules/accordion");
var calendar_pagination_1 = require("../modules/calendar_pagination");
var get_element_1 = require("../utils/get_element");
var IDS = {
    ARROW_LEFT_PC: 'js-calendar-arrow-left',
    ARROW_RIGHT_PC: 'js-calendar-arrow-right',
    ARROW_LEFT_SP: 'js-calendar-arrow-left_sp',
    ARROW_RIGHT_SP: 'js-calendar-arrow-right_sp',
    PREV_TEXT: 'js-calendar-prev-text',
    NEXT_TEXT: 'js-calendar-next-text',
    ACCORDION_CONTAINER: 'js-calendar-accordion-container',
};
/**
 * PC版カレンダーのページ切り替え処理を初期化
 */
var initPcCalendarChangeButton = function () {
    var prevButton = (0, get_element_1.getElementById)(IDS.ARROW_LEFT_PC);
    var nextButton = (0, get_element_1.getElementById)(IDS.ARROW_RIGHT_PC);
    new calendar_pagination_1.CalendarPagination(prevButton, nextButton);
};
/**
 * スマホ版カレンダーのページ切り替え処理を初期化
 */
var initSpCalendarChangeButton = function () {
    var prevButton = (0, get_element_1.getElementById)(IDS.ARROW_LEFT_SP);
    var nextButton = (0, get_element_1.getElementById)(IDS.ARROW_RIGHT_SP);
    var prevText = (0, get_element_1.getElementById)(IDS.PREV_TEXT);
    var nextText = (0, get_element_1.getElementById)(IDS.NEXT_TEXT);
    new calendar_pagination_1.CalendarPagination(prevButton, nextButton, function (page) {
        if (page === 'this') {
            prevText.classList.add(tailwind_1.TAILWIND_CLASSES.TEXT_DISABLE);
            nextText.classList.remove(tailwind_1.TAILWIND_CLASSES.TEXT_DISABLE);
        }
        else {
            prevText.classList.remove(tailwind_1.TAILWIND_CLASSES.TEXT_DISABLE);
            nextText.classList.add(tailwind_1.TAILWIND_CLASSES.TEXT_DISABLE);
        }
    });
};
var initCalendarAccordion = function () {
    var container = (0, get_element_1.getElementById)(IDS.ACCORDION_CONTAINER);
    new accordion_1.Accordion(container);
};
initPcCalendarChangeButton();
initSpCalendarChangeButton();
initCalendarAccordion();
